import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../cashierMenu.css';
import './variancePopup.css'; // Import variance popup styles
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import { useSelector } from 'react-redux';
import { getToken, getUserId, getUserName } from '../../../../Redux/selecters';
import { CashEnums, CounterNo } from '../../../../Enums/config';
import Select from 'react-select';
import { generateUniqueVoucherNumber } from '../../../services/globalService';

const OpeningCash = () => {
  let navigate = useNavigate();
  const [Currencies, setCurrency] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [employee, setEmploye] = useState({});
  const [noteQuantities, setNoteQuantities] = useState({});
  const [fillQuantities, setFillQuantities] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedCounter, setSelectedCounter] = useState(null);
  const location = useLocation();
  const counter = location.state?.selectedCounter;

  // Variance states
  const [showVariancePopup, setShowVariancePopup] = useState(false);
  const [varianceData, setVarianceData] = useState(null);
  const [varianceNote, setVarianceNote] = useState('');
  const [varianceAmount, setVarianceAmount] = useState('');
  // New state for validation error
  const [reasonError, setReasonError] = useState(false);

  let currency = 'EUR';
  const userId = useSelector(getUserId);
  const userName = useSelector(getUserName);

  useEffect(() => {
    GetCurrency();
    GetEmploye(userId);
  }, []);

  useEffect(() => {
    const initialQuantities = {};
    separateAndCountValues(Currencies, currency)?.forEach((item) => {
      initialQuantities[item.value] = item.count;
    });
    setQuantities(initialQuantities);
  }, [Currencies, currency]);

  const [formData, setFormData] = useState({
    user: '',
    toUser: '',
    date: '',
    handOverBranch: '',
    id: '',
    shift: '',
    note: '',
    digitalAmount: 0,
    counterNumber: '',
  });

  const GetEmploye = async () => {
    try {
      const apiService = new ApiService();
      let param = `?UserId=${userId}`;
      const res = await apiService.getApiParamater('GET_EMPLOYEE', param);

      let response = res?.data?.result;
      setEmploye(response[0]);
    } catch (error) {
      console.error(error);
    }
  };

  const sumFrom = (mapObj) =>
    Object.entries(mapObj).reduce((total, [val, qty]) => {
      const v = Number(val);
      const q = Number(qty) || 0;
      if (!Number.isFinite(v)) return total;
      return total + v * q;
    }, 0);

  const totalAmount = sumFrom(quantities);
  const totalCashAmount = sumFrom(noteQuantities);
  const totalFillsRaw = sumFrom(fillQuantities);
  const totalFills = totalFillsRaw;
  const grandTotalAmount = ((Number(formData?.digitalAmount) || 0) + totalAmount + totalCashAmount + totalFills).toFixed(2);

  const CheckVariance = async () => {
    try {
      const apiService = new ApiService();
      const params = {
        userId: userId,
        counterId: counter?.counterId,
        actualAmount: parseFloat(grandTotalAmount),
      };

      let param = `?UserId=${userId}&CounterId=${counter?.counterId}&InitialBalance=${parseFloat(grandTotalAmount)}`;
      const res = await apiService.getApiParamater('CHECK_VARIANCE', param);

      if (res?.data?.result?.hasVariance) {
        setVarianceData(res?.data?.result);
        debugger;
        setVarianceAmount(res?.data?.result?.varianceAmount || '');
        setShowVariancePopup(true);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error checking variance:', error);
      return false;
    }
  };

  const CreateCashOpen = async (skipVariance = false) => {
    try {
      setLoading(true);
      const now = new Date();
      const currentTime = `${now.getUTCHours().toString().padStart(2, '0')}:${now.getUTCMinutes().toString().padStart(2, '0')}:${now
        .getUTCSeconds()
        .toString()
        .padStart(2, '0')}`;

      const cashMeta = separateAndCountValues(Currencies, currency)
        ?.map((item) => {
          const coinQuantity = quantities[item.value] || 0;
          const noteQuantity = noteQuantities[item.value] || 0;
          const fillQuantity = fillQuantities[item.value] || 0;
          const totalQuantity = coinQuantity + noteQuantity + fillQuantity;

          if (totalQuantity > 0) {
            const type = coinQuantity > 0 ? 0 : noteQuantity > 0 ? 1 : 2;
            return {
              currencyDenominationId: item.currencyDenominationId,
              quantity: totalQuantity,
              type: type,
            };
          }
          return null;
        })
        .filter((item) => item !== null);

      const currentDatetimeUTC = new Date().toISOString();

      const datareq = {
        openedBy: employee?.id,
        openDateTime: currentDatetimeUTC,
        initialBalance: parseFloat(grandTotalAmount),
        remarks: formData?.note || '',
        status: 'open',
        loggedInUserId: userId,
        currencyDenomination: cashMeta,
        digitalAmount: formData?.digitalAmount,
        counterId: counter?.counterId,
        voucherNo: generateUniqueVoucherNumber(),
        // Variance fields
        varianceReason: varianceNote || '',
        variance: varianceAmount || 0,
        skipVariance: skipVariance,
      };

      const apiService = new ApiService();
      let res = await apiService.post('OPEN_DAY', datareq);

      if (res?.data?.statusCode === 201) {
        localStorage.setItem('Counter', JSON.stringify(res.data?.result));
        toast?.success('Cash Open Created Successfully');
        setShowVariancePopup(false);
        setVarianceNote('');
        setVarianceAmount('');
        navigate('/cashier/home');
      } else if (res?.data?.statusCode === 208 || res?.data?.statusCode === 417) {
        toast?.error(res?.data?.message || res?.message);
      } else {
        toast?.error(res?.data?.message || res?.message);
      }
    } catch (error) {
      console.error('Error Open Shift entry:', error);
      toast.error('Error creating cash opening');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    const hasVariance = await CheckVariance();
    if (!hasVariance) {
      await CreateCashOpen();
    }
  };

  const handleVarianceContinue = () => {
    // Check if reason is empty
    if (!varianceNote.trim()) {
      setReasonError(true); // Trigger UI error state
      toast.warning('Please provide a reason for the variance to continue.');
      return;
    }
    CreateCashOpen(false);
  };

  const handleVarianceSkip = () => {
    CreateCashOpen(true);
  };

  const handleClosePopup = () => {
    setShowVariancePopup(false);
    setReasonError(false);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const GetCurrency = async () => {
    try {
      const apiService = new ApiService();
      let param = '?UserToken=' + getToken() + '&UserNo=' + userId + '&LoggedInUserId=' + userId;
      const res = await apiService.getApiParamater('GET_CURRENCY', param);
      setCurrency(res?.data?.result);
    } catch (error) {
      console.error('Error fetching currency data:', error);
      toast.error('Error fetching currency data');
    }
  };

  const separateAndCountValues = (denominations) => {
    const filteredDenominations = denominations?.find((currency) => currency.default === true);
    return filteredDenominations?.currencyDenomination?.map((denomination) => {
      const count = denomination?.count || 0;
      return {
        currencyDenominationId: denomination?.currencyDenominationId,
        value: denomination?.value,
        count: count,
        type: denomination?.type,
      };
    });
  };

  const incrementQuantity = (value, type) => {
    if (type === 0) {
      setQuantities((prevState) => ({
        ...prevState,
        [value]: (prevState[value] || 0) + 1,
      }));
    }
  };

  const decrementQuantity = (value, type) => {
    if (type === 0) {
      setQuantities((prevState) => ({
        ...prevState,
        [value]: Math.max((prevState[value] || 0) - 1, 0),
      }));
    }
  };

  const incrementFillQuantity = (value, type) => {
    if (type === 2) {
      setFillQuantities((prevState) => ({
        ...prevState,
        [value]: (prevState[value] || 0) + 1,
      }));
    }
  };

  const decrementFillQuantity = (value, type) => {
    if (type === 2) {
      setFillQuantities((prevState) => ({
        ...prevState,
        [value]: Math.max((prevState[value] || 0) - 1, 0),
      }));
    }
  };

  const incrementNoteQuantity = (value, type) => {
    if (type === 1) {
      setNoteQuantities((prevState) => ({
        ...prevState,
        [value]: (prevState[value] || 0) + 1,
      }));
    }
  };

  const decrementNoteQuantity = (value, type) => {
    if (type === 1) {
      setNoteQuantities((prevState) => ({
        ...prevState,
        [value]: Math.max((prevState[value] || 0) - 1, 0),
      }));
    }
  };

  function getCurrentDate() {
    const today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    const yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    return yyyy + '-' + mm + '-' + dd;
  }

  const cashDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 1);
  const coinDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 0);
  const fillDenominations = separateAndCountValues(Currencies, currency)?.filter((item) => item.type === 2);

  const handleCounterChange = (selectedOption) => {
    setSelectedCounter(selectedOption);
    setFormData({ ...formData, counterNumber: selectedOption?.value });
  };

  return (
    <div className="p-lg-5">
      <div className="p-lg-5">
        <div className="row">
          <div className="col-lg-4 col-sm-4">
            <form>
              <div className="pb-lg-5">
                <div className="form-group row">
                  <div className="col-md-10 col-lg-10">
                    <label htmlFor="validationCustom01" className="form-label">
                      User
                    </label>
                    <input type="text" className="p-2 form-control" id="validationCustom01" name="user" value={userName} disabled required />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                  <div className="col-md-10  mt-3 col-lg-10">
                    <label htmlFor="validationCustom01" className="form-label">
                      Counter Name
                    </label>
                    <input type="text" className="p-2 form-control" id="validationCustom01" name="counterName" value={counter?.counterName} disabled required />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
                <div className="form-group row mt-3">
                  <div className="col-md-10">
                    <label htmlFor="validationCustom04" className="form-label">
                      Date
                    </label>
                    <input
                      type="date"
                      className="p-2 form-control"
                      id="validationCustom04"
                      name="date"
                      value={getCurrentDate()}
                      required
                      onChange={handleInputChange}
                      disabled
                    />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
                <div className="form-group row mt-3">
                  <div className="col-md-10">
                    <label htmlFor="validationCustom08" className="form-label">
                      Total
                    </label>
                    <input type="text" className="p-2 form-control" id="validationCustom08" name="amount" value={grandTotalAmount} required disabled />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
                <div className="form-group row mt-3">
                  <div className="col-md-10">
                    <label htmlFor="validationCustom08" className="form-label">
                      Digital Amount
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom08"
                      name="digitalAmount"
                      value={formData.digitalAmount}
                      onChange={handleInputChange}
                    />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
                <div className="form-group row mt-3 justify-content-between">
                  <div className="col-md-10">
                    <label htmlFor="validationCustom12" className="form-label">
                      Remarks
                    </label>
                    <textarea type="" className="p-2 form-control" id="validationCustom12" name="note" value={formData.note} onChange={handleInputChange} />
                    <div className="valid-feedback">Looks good!</div>
                  </div>
                </div>
                <div className="col-10 mt-5">
                  {loading ? (
                    <div className="addItem-btn center">
                      <ClipLoader loading={loading} size={30} color="#fff" />
                    </div>
                  ) : (
                    <div className="end">
                      <button className="addItem-btn" type="button" onClick={handleSave}>
                        Save
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
          {cashDenominations?.length === 0 ? (
            ' '
          ) : (
            <div className="col">
              <div className="">
                <div>Cash Denominations</div>
                <div className="borderMain mt-3 p-4">
                  {cashDenominations?.map((item, index) => (
                    <div className="row p-2 my-3 innerBorder" key={index}>
                      <div className="col-3">{item.value} X</div>
                      <div className="col-6 d-flex justify-content-between">
                        <div className="vr"></div>
                        <div className="quantity-control d-flex justify-content-around center">
                          <div onClick={() => decrementNoteQuantity(item.value, item?.type)} className="addbtn center">
                            -
                          </div>
                          <div className="center px-2">{noteQuantities[item.value] || 0}</div>
                          <div onClick={() => incrementNoteQuantity(item.value, item?.type)} className="addbtn center">
                            +
                          </div>
                        </div>
                        <div className="vr"></div>
                      </div>
                      <div className="col-3">{item.value * (noteQuantities[item.value] || 0)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {coinDenominations?.length === 0 ? (
            ' '
          ) : (
            <div className="col">
              <div className="">
                <div>Coin Denominations</div>
                <div className="borderMain mt-3 p-4">
                  {coinDenominations?.map((item, index) => (
                    <div className="row p-2 my-3 innerBorder" key={index}>
                      <div className="col-3">{item.value} X</div>
                      <div className="col-6 d-flex justify-content-between">
                        <div className="vr"></div>
                        <div className="quantity-control d-flex justify-content-around center">
                          <div onClick={() => decrementQuantity(item.value, item?.type)} className="addbtn center">
                            -
                          </div>
                          <div className="center px-2">{quantities[item.value] || 0}</div>
                          <div onClick={() => incrementQuantity(item.value, item?.type)} className="addbtn center">
                            +
                          </div>
                        </div>
                        <div className="vr"></div>
                      </div>
                      <div className="col-3">{item.value * (quantities[item.value] || 0)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
          {fillDenominations?.length === 0 ? (
            ' '
          ) : (
            <div className="col">
              <div className="">
                <div>Cents Denominations</div>
                <div className="borderMain mt-3 p-4">
                  {fillDenominations?.map((item, index) => (
                    <div className="row p-2 my-3 innerBorder" key={index}>
                      <div className="col-3">{item.value} X</div>
                      <div className="col-6 d-flex justify-content-between">
                        <div className="vr"></div>
                        <div className="quantity-control d-flex justify-content-around center">
                          <div onClick={() => decrementFillQuantity(item.value, item?.type)} className="addbtn center">
                            -
                          </div>
                          <div className="center px-2">{fillQuantities[item.value] || 0}</div>
                          <div onClick={() => incrementFillQuantity(item.value, item?.type)} className="addbtn center">
                            +
                          </div>
                        </div>
                        <div className="vr"></div>
                      </div>
                      <div className="col-3">{(item.value * (fillQuantities[item.value] || 0)).toFixed(2)}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Variance Detection Popup */}
      {showVariancePopup && (
        <div className="variance-popup-overlay">
          {/* Added position:relative style to enable absolute positioning of the close icon */}
          <div className="variance-popup-container" style={{ position: 'relative' }}>
            {/* CLOSE ICON - Requirement 1 */}
            <div
              className="close-popup-icon"
              onClick={handleClosePopup}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                cursor: 'pointer',
                zIndex: 10,
              }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 6L18 18" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>

            <div className="variance-popup-header">
              <div className="variance-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2 17L12 22L22 17" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2 12L12 17L22 12" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3 className="variance-title">Variance Detected</h3>
              <p className="variance-subtitle">There's a discrepancy in the cash count</p>
            </div>

            <div className="variance-popup-body">
              <div className="variance-info-card">
                <div className="variance-row">
                  <span className="variance-label">Expected Amount:</span>
                  <span className="variance-value">
                    {currency} {varianceData?.lastFinalBalance?.toFixed(2) || '0.00'}
                  </span>
                </div>
                <div className="variance-row">
                  <span className="variance-label">Actual Amount:</span>
                  <span className="variance-value">
                    {currency} {grandTotalAmount}
                  </span>
                </div>
                <div className="variance-divider"></div>
                <div className="variance-row variance-highlight">
                  <span className="variance-label">Variance:</span>
                  <span className={`variance-value ${parseFloat(varianceAmount) < 0 ? 'text-danger' : 'text-success'}`}>
                    {currency} {Math.abs(parseFloat(varianceAmount)).toFixed(2)}
                    {parseFloat(varianceAmount) < 0 ? ' (Short)' : ' (Over)'}
                  </span>
                </div>
              </div>

              <div className="variance-form">
                <div className="form-group">
                  <label htmlFor="varianceAmount" className="variance-form-label">
                    Variance Amount <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="variance-input"
                    id="varianceAmount"
                    value={varianceAmount}
                    onChange={(e) => setVarianceAmount(e.target.value)}
                    placeholder="0.00"
                    step="0.01"
                    disabled
                  />
                </div>

                <div className="form-group mt-3">
                  <label htmlFor="varianceNote" className="variance-form-label">
                    Reason for Variance <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="variance-textarea"
                    id="varianceNote"
                    rows="4"
                    value={varianceNote}
                    // Requirement 2: Visual feedback for required field
                    style={reasonError ? { border: '1px solid red' } : {}}
                    onChange={(e) => {
                      setVarianceNote(e.target.value);
                      if (e.target.value.trim()) setReasonError(false);
                    }}
                    placeholder="Please explain the reason for this variance..."
                    required
                  />
                  {reasonError && <small className="text-danger">Reason is required to continue.</small>}
                  {!reasonError && <small className="variance-hint">Provide a detailed explanation for record keeping</small>}
                </div>
              </div>
            </div>

            <div className="variance-popup-footer">
              <button className="variance-btn variance-btn-skip" onClick={handleVarianceSkip} disabled={loading}>
                {loading ? 'Processing...' : 'Skip & Continue'}
              </button>
              <button className="variance-btn variance-btn-continue" onClick={handleVarianceContinue} disabled={loading}>
                {loading ? <ClipLoader loading={loading} size={20} color="#fff" /> : 'Continue with Note'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(OpeningCash);
